import { FC } from "react";
import { formatRouteText } from "../navigation/utils";

interface HeaderProps {
    institutionName: string;
}

const Header: FC<HeaderProps> = ({ institutionName }) => {

    return (
        <h1 className="header">
            {formatRouteText(institutionName)}
        </h1>
    )
}

export default Header;